module.exports = __webpack_public_path__ + "img/2-3.9332ff91.png";